export default __webpack_public_path__ + "static/neue-haas-grotesk-text-55-roman-df5f06ffed5260ee879513a2bbfc651e.woff";